/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Few_Legal_Carp_LendInputs */

const es_few_legal_carp_lend = /** @type {(inputs: Few_Legal_Carp_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos y Condiciones`)
};

const gl_few_legal_carp_lend = /** @type {(inputs: Few_Legal_Carp_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos e condicións`)
};

const en_few_legal_carp_lend = /** @type {(inputs: Few_Legal_Carp_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and Conditions`)
};

/**
* | output |
* | --- |
* | "Terms and Conditions" |
*
* @param {Few_Legal_Carp_LendInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const few_legal_carp_lend = /** @type {((inputs?: Few_Legal_Carp_LendInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Few_Legal_Carp_LendInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_few_legal_carp_lend(inputs)
	if (locale === "en") return en_few_legal_carp_lend(inputs)
	return es_few_legal_carp_lend(inputs)
});